import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCopy } from '@/hooks/useCopy';

export function NotFound() {
  const { t } = useCopy();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          {t('errors.notFoundTitle', 'Not found')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t('errors.notFoundBody', "We couldn't find what you were looking for.")}
        </Typography>
        <Box>
          <Button component={RouterLink} to="/" variant="contained">
            {t('nav.home', 'Home')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
